(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    


$('.search').click(function(){
	$('.search-modal-container').show();
});

$('.icon-close-container').click(function(){
	$('.search-modal-container').hide();
});


var $menu = $("#torbreck-menu").mmenu({
		"extensions": [
	        "border-full",
			"theme-dark",
			"pagedim",
			"shadow-page",
			"fx-menu-fade"
	    ],
	   	// options
	   	offCanvas: {
			position: "right"
		}
	}, {
   		// configuration
   		clone: true,
   		offCanvas: {
			pageSelector: "#mmenu-wrapper",
	  	}
	});

var $icon = $("#hamburger");
var API = $menu.data( "mmenu" );

$icon.on( "click", function() {
   API.open();
});

API.bind( "open:finish", function() {
   setTimeout(function() {
      $icon.addClass( "is-active" );
   }, 100);
});
API.bind( "close:finish", function() {
   setTimeout(function() {
      $icon.removeClass( "is-active" );
   }, 100);
});

var li = '<li><a href="/pages/contact-us/">Contact Us</a></li>';
li += '<li><a href="https://www.dropbox.com/sh/yz0sfb5vmm6gfwo/AAC9ZDnPcD1Q9MXpkV-DPbeKa?dl=0" target="_blank">Trade Centre</a></li>';
li += '<li><a href="/cart/">Cart</a></li>';
li += '<li><a href="/account/login">Member Login</a></li>';
li += '<li><a href="/collections/the-torbreck-wine-club-exclusive-offers">Exclusive Offers</a></li>';
li += '<li><a href="/pages/join-the-clan/" class="join-the-clan-button">Join The Clan</a></li>';

//   #my-list was an UL, now is a panel

$("#mm-torbreck-menu").find( ".mm-listview" ).first().append( li );

API.initPanels( $("#mm-torbreck-menu") );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

var spins = document.getElementsByClassName("product-quantity");
for (var i = 0, len = spins.length; i < len; i++) {
                                            var spin = spins[i],
                                            span = spin.getElementsByTagName("span"),
                                            input = spin.getElementsByTagName("input")[0];

                                            input.onchange = function() { input.value = +input.value || 0; };
                                            span[0].onclick = function() { input.value = Math.max(0, input.value - 1); };
                                            span[1].onclick = function() { input.value -= -1; };
                                            }

                                            // 1st carousel, main
                                            var $productMain = $('.product-main').flickity({ "pageDots": false, "prevNextButtons": false, "imagesLoaded": true, "dragThreshold": 10 });
                                            // 2nd carousel, navigation
                                            var $productNav = $('.product-nav').flickity({ "asNavFor": ".product-main", "contain": true, "pageDots": false, "prevNextButtons": false, "imagesLoaded": true, "cellAlign": "left" });

                                            $productNav.on('select.flickity', function(){
                                            var demoTrigger = document.querySelector('.is-selected');
                                            var paneContainer = document.querySelector('.product-main');

                                            new Drift(demoTrigger, {
                                            paneContainer: paneContainer,
                                            inlinePane: false,
                                            zoomFactor: 2,
                                            handleTouch: false,
                                            touchDelay: 500
                                            });
                                            });

                                            $('.vintages').find('.product-accordion').hide();
                                            $('.vintages').find('.product-title').click(function(){
                                            $(this).toggleClass('title-toggled');
                                            $(this).parent().find('.product-accordion').slideToggle(200);
                                            $(".product-accordion").not($(this).parent().find('.product-accordion')).slideUp(200);
                                            $(".product-title").not($(this).parent().find('.product-title')).removeClass('title-toggled')
                                            });

                                            if (!$.trim($(".quote").html())) {
                                            //do something
                                            $('.quote').hide();
                                            }

                                            if (!$.trim($(".vintages").html())) {
                                            //do something
                                            $('.vintages').hide();
                                            }

                                            if ( (!$.trim($(".quote").html())) && (!$.trim($(".vintages").html())) ) {
                                            //do something
                                            $('.vintages_and_quote_header').hide();
                                            }

                                            $('.show-more').click(function(){
                                            console.log('Show more clicked');
                                            $(this).closest(".product-description-inner").toggleClass("expanded");
                                            $(this).toggleClass("expanded");
                                            });

                                            $(document).ready(function(){
                                            var currentValue = $('select[data-index="option1"]').val();

                                            if((currentValue.includes("3L")) || (currentValue.includes("6L")) || (currentValue.includes("18L")) || (currentValue.includes("27L"))) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.limited-stock').show();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else if(currentValue.includes("Pre-order")) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.new-release').show();
                                            $('.limited-stock').hide();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else if(currentValue.includes("Limited Stock")) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.limited-stock').show();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else {
                                            $('.product-quantity').show();
                                            $('.data-add-to-cart-text, .product-price').show();
                                            $('.limited-stock').hide();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').removeClass('limitedstock');
                                            }
                                            });

                                            $('select[data-index="option1"]').change(function(){
                                            var currentValue = $(this).val();

                                            if((currentValue.includes("3L")) || (currentValue.includes("6L")) || (currentValue.includes("18L")) || (currentValue.includes("27L"))) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.limited-stock').show();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else if(currentValue.includes("Pre-order")) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.limited-stock').hide();
                                            $('.new-release').show();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else if(currentValue.includes("Limited Stock")) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.new-release').hide();
                                            $('.limited-stock').show();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else {
                                            $('.product-quantity').show();
                                            $('.data-add-to-cart-text, .product-price').show();
                                            $('.limited-stock').hide();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').removeClass('limitedstock');
                                            }
                                            });

                                            
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product2"]) return;
  try {
    

var spins = document.getElementsByClassName("product-quantity");
for (var i = 0, len = spins.length; i < len; i++) {
                                            var spin = spins[i],
                                            span = spin.getElementsByTagName("span"),
                                            input = spin.getElementsByTagName("input")[0];

                                            input.onchange = function() { input.value = +input.value || 0; };
                                            span[0].onclick = function() { input.value = Math.max(0, input.value - 1); };
                                            span[1].onclick = function() { input.value -= -1; };
                                            }

                                            // 1st carousel, main
                                            var $productMain = $('.product-main').flickity({ "pageDots": false, "prevNextButtons": false, "imagesLoaded": true, "dragThreshold": 10 });
                                            // 2nd carousel, navigation
                                            var $productNav = $('.product-nav').flickity({ "asNavFor": ".product-main", "contain": true, "pageDots": false, "prevNextButtons": false, "imagesLoaded": true, "cellAlign": "left" });

                                            $productNav.on('select.flickity', function(){
                                            var demoTrigger = document.querySelector('.is-selected');
                                            var paneContainer = document.querySelector('.product-main');

                                            new Drift(demoTrigger, {
                                            paneContainer: paneContainer,
                                            inlinePane: false,
                                            zoomFactor: 2,
                                            handleTouch: false,
                                            touchDelay: 500
                                            });
                                            });

                                            $('.vintages').find('.product-accordion').hide();
                                            $('.vintages').find('.product-title').click(function(){
                                            $(this).toggleClass('title-toggled');
                                            $(this).parent().find('.product-accordion').slideToggle(200);
                                            $(".product-accordion").not($(this).parent().find('.product-accordion')).slideUp(200);
                                            $(".product-title").not($(this).parent().find('.product-title')).removeClass('title-toggled')
                                            });

                                            if (!$.trim($(".quote").html())) {
                                            //do something
                                            $('.quote').hide();
                                            }

                                            if (!$.trim($(".vintages").html())) {
                                            //do something
                                            $('.vintages').hide();
                                            }

                                            if ( (!$.trim($(".quote").html())) && (!$.trim($(".vintages").html())) ) {
                                            //do something
                                            $('.vintages_and_quote_header').hide();
                                            }

                                            $('.show-more').click(function(){
                                            console.log('Show more clicked');
                                            $(this).closest(".product-description-inner").toggleClass("expanded");
                                            $(this).toggleClass("expanded");
                                            });

                                            $(document).ready(function(){
                                            var currentValue = $('select[data-index="option1"]').val();

                                            if((currentValue.includes("3L")) || (currentValue.includes("6L")) || (currentValue.includes("18L")) || (currentValue.includes("27L"))) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.limited-stock').show();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else if(currentValue.includes("Pre-order")) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.new-release').show();
                                            $('.limited-stock').hide();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else if(currentValue.includes("Limited Stock")) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.limited-stock').show();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else {
                                            $('.product-quantity').show();
                                            $('.data-add-to-cart-text, .product-price').show();
                                            $('.limited-stock').hide();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').removeClass('limitedstock');
                                            }
                                            });

                                            $('select[data-index="option1"]').change(function(){
                                            var currentValue = $(this).val();

                                            if((currentValue.includes("3L")) || (currentValue.includes("6L")) || (currentValue.includes("18L")) || (currentValue.includes("27L"))) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.limited-stock').show();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else if(currentValue.includes("Pre-order")) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.limited-stock').hide();
                                            $('.new-release').show();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else if(currentValue.includes("Limited Stock")) {
                                            $('.product-quantity').hide();
                                            $('.data-add-to-cart-text, .product-price').hide();
                                            $('.new-release').hide();
                                            $('.limited-stock').show();
                                            $('.add-to-cart-button').addClass('limitedstock');
                                            } else {
                                            $('.product-quantity').show();
                                            $('.data-add-to-cart-text, .product-price').show();
                                            $('.limited-stock').hide();
                                            $('.new-release').hide();
                                            $('.add-to-cart-button').removeClass('limitedstock');
                                            }
                                            });

                                            
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !window.DesignMode) return;
  try {
    

var theVideo = document.getElementById('theVideo');
var thePoster = theVideo.dataset.videoposter;
var players = plyr.setup('.plyr-video');

$('.the_play_button').click(function(){
	players[0].play();
	$(this).fadeOut(100);
	$('.video-poster').fadeOut(100);
});

players[0].on('ended', function(event) {
  players[0].rewind(players[0].getDuration());
  $('.the_play_button').fadeIn(100);
  $('.video-poster').fadeIn(100);
});


  } catch(e) { console.error(e); }
})();
})();
